export default __webpack_public_path__ + "static/media/bh.9a71f360.webp";